import { useState } from 'react';
import { Typography, Button, Stack, IosShareOutlinedIcon, ExplorerPlusIcon } from 'src/components';
import { useAuth } from 'src/utils';
import { useIsMobile } from 'src/hooks';
import MembershipsModal from 'src/pages/memberships/memberships-modal';

export default function ExplorerPlusButtons() {
    const [displayMembershipsModal, setDisplayMembershipsModal] = useState(false);

    const isMobile = useIsMobile();
    const { user } = useAuth();
    const freeMembership = !user || user?.membership === "Free";

    const isMembershipsEnabled = import.meta.env.VITE_FEATURE_MEMBERSHIPS === 'true';

    var referralLink = "https://www.panamhighway.com/";

    const shareData = {
        title: 'Join me on PanAm Explorer!',
        text: 'Check out this travel app for the Pan-American Highway.',
        url: referralLink || window.location.href,
    };

    const handleInviteClick = async () => {
        if (navigator.share) {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Share failed:', err);
        }
        } else {
        // Fallback: copy link to clipboard
        try {
            await navigator.clipboard.writeText(shareData.url);
            alert('Invite link copied to clipboard!');
        } catch {
            alert('Sharing is not supported on this browser.');
        }
        }
    };

    return (
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <Button
                variant={freeMembership ? "outlined" : "contained"}
                size="small"
                startIcon={<IosShareOutlinedIcon/>}
                sx={{
                    bgcolor: freeMembership ? 'tranparent' : 'secondary.main',
                    borderRadius: 2,
                    padding: 1,
                    width: freeMembership ? '50%' : '100%',
                    height: isMobile ? '40px' : '30px',
                    justifyContent: 'center',
                    borderColor: '#ccc'
                }}
                onClick={handleInviteClick}>
                <Typography variant={isMobile ? "body2" : "body3"} fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
                    Invite Friends
                </Typography>
            </Button>

            {freeMembership && (
                <Button
                    variant="contained"
                    disabled={!isMembershipsEnabled}
                    sx={{
                        bgcolor: 'secondary.main',
                        borderRadius: 2,
                        padding: 1,
                        color: '#fff',
                        width: '50%',
                        height: isMobile ? '40px' : '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        '&:hover': {
                            backgroundColor: 'secondary.dark',
                        }}}
                        onClick={() => setDisplayMembershipsModal(true)}
                        startIcon={
                            <ExplorerPlusIcon 
                                tier="ambassador"
                                size={22}
                                variant="animated"
                            />
                        }>

                        <Typography variant={isMobile ? "body2" : "body3"} fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
                            Explorer Plus
                        </Typography>
                        
                </Button>
            )}

            {displayMembershipsModal && (
                <MembershipsModal
                    open={displayMembershipsModal}
                    onClose={() => setDisplayMembershipsModal(false)}
                />
            )}

        </Stack>
    );
}